import Button from "../Reusable Elements/Button";
import styles from "../../styles/DemoProjects.module.css";
import { useNavigate } from "react-router-dom";

export default function DemoProjects() {
    const navigate = useNavigate();

    return (
        <div className="bg-primary-blue">
            <div className="flex justify-center w-full pt-12 flex-col sm:flex-row gap-x-6">
                <div className="sm:w-1/3 text-primary-white font-poppins font-extralight text-5xl text-center flex flex-col justify-center">
                    Projects
                </div>
                <div className="sm:w-1/3 text-primary-gold flex justify-center font-poppins font-extralight text-3xl sm:mt-0 mt-9">
                    <div className={styles.projectCardBackground}>
                        <div
                            className={styles.projectCard}
                            onClick={() => navigate("/pearl-residencia")}
                        >
                            Pearl Residencia
                        </div>
                    </div>
                </div>
                <div className="w-1/3 text-primary-white text-center flex-col justify-center items-center gap-y-6 hidden sm:flex">
                    <div className="w-[250px] bg-primary-gold font-poppins font-light text-3xl py-5">
                        5 Marla
                    </div>
                    <div className="w-[250px] bg-primary-gold font-poppins font-light text-3xl py-5">
                        4 Marla
                    </div>
                    <div className="w-[250px] bg-primary-gold font-poppins font-light text-3xl py-5">
                        Townhomes
                    </div>
                </div>
            </div>
            <div className="pt-12 flex justify-center pb-12">
                <Button
                    text={"See More"}
                    color={"#022051"}
                    location={"/projects"}
                />
            </div>
        </div>
    );
}
